import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import localesMap from '../../localesMap';

export const availableLocales = Object.values(localesMap) as TLocale[];
